import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M21.334 31.698V.318c1.738.207 3.27.52 4.357.945 4.447 1.728 5.476 6.646 5.476 6.646.664 2.757.863 5.582.83 8.107.033 2.493-.2 5.317-.863 8.108 0 0-1.029 4.918-5.477 6.646-1.07.425-2.59.728-4.323.928",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M21.333.318v31.38c-1.654.19-3.502.286-5.333.302a51 51 0 0 1-5.334-.314V.314A51 51 0 0 1 16 0c1.83.016 3.676.12 5.333.318",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      fillRule: "evenodd",
      d: "M10.667.314v31.372c-1.733-.204-3.255-.508-4.325-.916C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.318.863-8.109 0 0 1.03-4.918 5.476-6.646C7.412.821 8.934.518 10.667.314",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagMli = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagMli_default = SvgFlagMli;

export { FlagMli_default as default };
